module.exports = __webpack_public_path__ + "static/img/cont39_02.ef5830e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont39_02.png
// module id = 4Ts3
// module chunks = 0